import './FooterModalTwoStepAuthenticationConfig';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import AtomButton from '../../../../atoms/AtomButton/AtomButton';
import AtomGrid from '../../../../atoms/AtomGrid';
import { styleConfigs } from '../../../../resources/styleConfigs';

interface IFooterModalTwoStepAuthenticationParams {
  disabledDoneButton: boolean;
  handleCancelFooterModal: VoidFunction;
  handleDoneFooterModal: VoidFunction;
}

const FooterModalTwoStepAuthentication: FC<IFooterModalTwoStepAuthenticationParams> = (props) => {
  const { disabledDoneButton, handleCancelFooterModal, handleDoneFooterModal } = props;
  const { t } = useTranslation('FooterModalTwoStepAuthentication');

  return (
    <AtomGrid
      display="flex"
      py={styleConfigs.marginPadding.custom2}
      px={styleConfigs.marginPadding.custom3}
      gap={styleConfigs.marginPadding.custom2}
    >
      <AtomButton
        variant="outlined"
        onClick={handleCancelFooterModal}
        sx={{
          borderRadius: styleConfigs.borders.radius4rem,
        }}
        data-testid="cancel_two_step_button"
        data-cy-button-type="cancel_two_step"
      >
        {t('CANCEL_BUTTON')}
      </AtomButton>
      <AtomButton
        variant="contained"
        onClick={handleDoneFooterModal}
        disabled={disabledDoneButton}
        sx={{
          borderRadius: styleConfigs.borders.radius4rem,
        }}
        data-testid="done_two_step_button"
        data-cy-button-type="done_two_step"
        data-cy-disabled={disabledDoneButton}
      >
        {t('DONE_BUTTON')}
      </AtomButton>
    </AtomGrid>
  );
};

export default FooterModalTwoStepAuthentication;
